import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable()
export class EmailService {
    private emblanoUrl = environment.emblanoUrl;
    private host = environment.host;

    constructor(private http: Http) { }

    sendSalesNote(id: string,subject:string): Observable<any> {
        return this.http.get(this.host + '/api/email/sendSalesNote?customerId=' + id + '&subject=' + subject + '&sessionId=' + localStorage.getItem("sessionID"), JSON.stringify({}))
            .map((response: Response) => {
                return response.status;
            });
    }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/services/email.service.ts